// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-about-media{padding:12px}@media only screen and (min-width:992px){.home-about-media{flex-basis:50%;max-width:50%;padding:0}}.home-about-media__inner{position:relative;height:100%;padding-bottom:56.25%}.home-about-media__video{position:absolute;top:0;bottom:0;left:0;right:0;display:block;max-width:100%;width:100%;height:100%;object-fit:cover}", ""]);
// Exports
module.exports = exports;
